import {
  Image,
  ImageBackground,
  Modal,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  ScrollView,
} from "react-native";
import React, { useEffect, useState } from "react";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../../../utility/AppColors";
import { AppImages } from "../../../../utility/AppImages";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { toast } from "react-toastify";
import { base_url, endpoints } from "../../../../Api/configs";
import { ShowLoader } from "../../../../common/ShowLoader";
import {
  fetchPaymentBeltExchange,
  fetchPaymentRequestSell,
} from "../../../../services/profileAPI";
import { handleApiError } from "../../../../services/errorHandler";
import UpgradeComponent from "../../../../Components/home-common-components/UpgradeComponent";
import { useAuthProvider } from "../../../../context/AuthContext";
import Separator from "../../../../Components/Separator";
import { CommonButton } from "../../../../common/CommonButton";
import TimerComponent from "../../../../Components/ongoing-common-components/general-components/TimerComponent";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { getLoginData } from "../../../../utility/AppStoreData";
import moment from "moment";
import { checkInEvent } from "../../../../services/eventsAPI";

export default function FinalWarning(props) {
  const {
    showModal = false,
    setShowModal,
    eventData,
    setArrIveOrganizedList,
    setArrChallengeList,
    setArrWatchingList,
    notificationId,
  } = props;

  const onCloseClick = () => {
    setShowModal(false);
  };

  const currentUser = localStorage.getItem("username");
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [showLoader, setShowLoader] = useState(false);
  const currentDate = new Date();
  const [userData, setUserData] = useState(null);
  const [accessToken, setAccessToken] = useState("");
  const [noTimeLeft, setNoTimeLeft] = useState(false);
  const [checkInTimeLeftUTC, setcheckInTimeLeftUTC] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [timeLeftUTC, setTimeLeftUTC] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    async function getLoginUserData() {
      const data = await getLoginData();
      if (data != null) {
        setUserData(data);
        if (data.AccessToken) {
          setAccessToken(data.AccessToken);
          // checkEventId();
        }
      }
    }
    getLoginUserData();
  }, []);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const eventStartTime = new Date(
        eventData?.details?.eventStartTime
      ).getTime();

      if (eventData && eventData?.details?.eventStartTime) {
        const eventDate = new Date(
          eventData?.details?.eventStartTime
        ).getTime();
        const now = Date.now();
        const difference = eventDate - now;
        if (difference > 0) {
          setTimeLeftUTC({
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / 1000 / 60) % 60),
            seconds: Math.floor((difference / 1000) % 60),
          });
        } else {
          setTimeLeftUTC({
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
          });
        }
      }

      if (eventData && eventData?.details?.eventStartTime) {
        const checkInTime =
          new Date(eventData?.details?.eventStartTime).getTime() +
          1.5 * 60 * 60 * 1000;
        const now = Date.now();
        const difference = checkInTime - now;
        if (difference > 0) {
          setcheckInTimeLeftUTC({
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / 1000 / 60) % 60),
            seconds: Math.floor((difference / 1000) % 60),
          });
        } else {
          setcheckInTimeLeftUTC({
            hours: 0,
            minutes: 0,
            seconds: 0,
          });
          setNoTimeLeft(true);
        }
      }
    };

    const startDate = new Date(eventData?.details?.eventStartTime);
    const timeDifference = startDate.getTime() - currentDate.getTime();
    const hoursLeft = timeDifference / (1000 * 60 * 60);

    const interval = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(interval);
  }, [eventData]);

  const confirmEventCheckInStatus = async (accessToken, eventId) => {
    setShowLoader(true);
    try {
      const response = await checkInEvent(accessToken, eventId);
      if (response.statusCode === 200) {
        toast.success("Event check-in confirmed successfully");
        if (eventData?.details?.organiserId === currentUser) {
          if (!eventData.details.checkInStatus) {
            eventData.details.checkInStatus = {
              organiser: false,
              challenger: false,
            };
          }
          eventData.details.checkInStatus.organiser = true;
        } else if (eventData?.details?.challengerId === currentUser) {
          if (!eventData.details.checkInStatus) {
            eventData.details.checkInStatus = {
              organiser: false,
              challenger: false,
            };
          }
          eventData.details.checkInStatus.challenger = true;
        }
        const updateList = (list) =>
          list.map((notification) =>
            notification.notificationId === notificationId
              ? { ...notification, actionStatus: "confirmed" }
              : notification
          );
        setArrIveOrganizedList((prev) => updateList(prev));
        setArrChallengeList((prev) => updateList(prev));
        setArrWatchingList((prev) => updateList(prev));
        setShowModal(false);
      } else if (response.statusCode === 400 || response.statusCode === 403) {
        toast.error(response.body.error);
      }
    } catch (error) {
      toast.error("Failed to confirm event check-in");
      console.error("Error confirming event check-in:", error);
    } finally {
      setShowLoader(false);
    }
  };

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <View style={styles.container}>
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            justifyContent: "center",
          }}
          style={styles.scrollView}
        >
          <View style={styles.mainView}>
            {/* Header view */}
            <View style={styles.headerView}>
              <View
                style={{
                  flex: 1,
                  alignSelf: "center",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Text style={[AppFontStyle.BOLD_ANYBODY_24, styles.headerText]}>
                  Final Warning: Confirm Now!
                </Text>
                <TouchableOpacity onPress={onCloseClick} activeOpacity={0.5}>
                  <Image
                    source={AppImages.icCloseWhite}
                    style={{
                      height: 28,
                      width: 28,
                      resizeMode: "contain",
                    }}
                  />
                </TouchableOpacity>
              </View>
            </View>
            <Separator
              color={AppColors.gray_838383}
              height={1}
              marginTop={8}
              marginBottom={0}
              marginHorizontal={0}
            />
            <View
              style={{
                gap:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? 12
                    : 22,
                marginTop: 22,
              }}
            >
              <View style={{ alignItems: "center" }}>
                <Image
                  source={AppImages.icCaution}
                  style={{
                    height:
                      deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM
                        ? 100
                        : 131,
                    width:
                      deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM
                        ? 100
                        : 131,
                    resizeMode: "contain",
                    marginBottom: 8,
                  }}
                />
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_22,
                    { color: AppColors.red_AF0707 },
                  ]}
                >
                  {checkInTimeLeftUTC.minutes} minutes left
                </Text>
              </View>
              <View style={{ alignItems: "center" }}>
                <View style={styles.timeContainer}>
                  <View
                    style={{
                      alignItems: "center",
                      marginTop: 10,
                    }}
                  >
                    <Text
                      style={[
                        AppFontStyle.BOLD_ANYBODY_24,
                        {
                          padding: 10,
                          borderRadius: 10,
                          backgroundColor: AppColors.white,
                          color: AppColors.red_FA0A0A,
                        },
                      ]}
                    >
                      {timeLeftUTC.days < 10 ? "0" : ""}
                      {timeLeftUTC.days}
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        { color: AppColors.gray_C4C4C4, marginTop: 2 },
                      ]}
                    >
                      Days
                    </Text>
                  </View>
                  <View
                    style={{
                      alignItems: "center",
                      marginTop: 10,
                    }}
                  >
                    <Text
                      style={[
                        AppFontStyle.BOLD_ANYBODY_24,
                        {
                          backgroundColor: AppColors.white,
                          color: AppColors.red_FA0A0A,
                          padding: 10,
                          borderRadius: 10,
                        },
                      ]}
                    >
                      {timeLeftUTC.hours < 10 ? "0" : ""}
                      {timeLeftUTC.hours}
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        { color: AppColors.gray_C4C4C4, marginTop: 2 },
                      ]}
                    >
                      Hours
                    </Text>
                  </View>
                  <View
                    style={{
                      alignItems: "center",
                      marginTop: 10,
                    }}
                  >
                    <Text
                      style={[
                        AppFontStyle.BOLD_ANYBODY_24,
                        {
                          backgroundColor: AppColors.white,
                          color: AppColors.red_FA0A0A,
                          padding: 10,
                          borderRadius: 10,
                        },
                      ]}
                    >
                      {timeLeftUTC.minutes < 10 ? "0" : ""}
                      {timeLeftUTC.minutes}
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        { color: AppColors.gray_C4C4C4, marginTop: 2 },
                      ]}
                    >
                      Minutes
                    </Text>
                  </View>
                  <View
                    style={{
                      alignItems: "center",
                      marginTop: 10,
                    }}
                  >
                    <Text
                      style={[
                        AppFontStyle.BOLD_ANYBODY_24,
                        {
                          backgroundColor: AppColors.white,
                          color: AppColors.red_FA0A0A,
                          padding: 10,
                          borderRadius: 10,
                        },
                      ]}
                    >
                      {timeLeftUTC.seconds < 10 ? "0" : ""}
                      {timeLeftUTC.seconds}
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        { color: AppColors.gray_C4C4C4, marginTop: 2 },
                      ]}
                    >
                      Seconds
                    </Text>
                  </View>
                </View>
              </View>
              <View>
                <Text
                  style={[
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? AppFontStyle.BOLD_ANYBODY_12
                      : AppFontStyle.BOLD_ANYBODY_18,
                    {
                      lineHeight:
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? 16
                          : 22,
                    },
                  ]}
                >
                  Hi {eventData.userId},
                </Text>
                <Text
                  style={[
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? AppFontStyle.BOLD_ANYBODY_12
                      : AppFontStyle.BOLD_ANYBODY_18,
                    ,
                    {
                      lineHeight:
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? 16
                          : 22,
                    },
                  ]}
                >
                  You haven’t confirmed your participation for the event at{" "}
                  {moment(eventData?.details?.eventStartTime).format(
                    "MMMM Do YYYY, h:mm a"
                  )}
                </Text>
                <Text
                  style={[
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? AppFontStyle.BOLD_ANYBODY_12
                      : AppFontStyle.BOLD_ANYBODY_18,
                    {
                      lineHeight:
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? 16
                          : 22,
                    },
                  ]}
                >
                  If you don’t confirm in 30 minutes, you risk:
                </Text>
                <Text
                  style={[
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? AppFontStyle.BOLD_ANYBODY_12
                      : AppFontStyle.BOLD_ANYBODY_18,
                    {
                      lineHeight:
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? 16
                          : 22,
                    },
                  ]}
                >
                  1. Losing your spot.
                </Text>
                <Text
                  style={[
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? AppFontStyle.BOLD_ANYBODY_12
                      : AppFontStyle.BOLD_ANYBODY_18,
                    {
                      lineHeight:
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? 16
                          : 22,
                    },
                  ]}
                >
                  2. Losing your wager to the prize pool.
                </Text>
                <Text
                  style={[
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? AppFontStyle.BOLD_ANYBODY_12
                      : AppFontStyle.BOLD_ANYBODY_18,
                    {
                      lineHeight:
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? 16
                          : 22,
                      marginTop: 10,
                    },
                  ]}
                >
                  Click below to confirm now:
                </Text>
              </View>
              <View style={{ alignItems: "center" }}>
                <CommonButton
                  buttonStyle={styles.CheckNowButtonStyle}
                  disabled={
                    noTimeLeft ||
                    showLoader ||
                    (eventData.details.checkInStatus?.organiser &&
                      eventData?.details?.organiserId === currentUser) ||
                    (eventData.details.checkInStatus?.challenger &&
                      eventData?.details?.challengerId === currentUser)
                  }
                  disabledCustomStyle={{ opacity: 0.5 }}
                  textStyle={[AppFontStyle.SEMIBOLD_ANYBODY_14, {}]}
                  title="Check In Now"
                  onTap={() => {
                    confirmEventCheckInStatus(accessToken, eventData.eventId);
                  }}
                />
              </View>
              <View>
                <Text
                  style={[
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? AppFontStyle.BOLD_ANYBODY_12
                      : AppFontStyle.BOLD_ANYBODY_18,
                    {
                      lineHeight:
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? 16
                          : 22,
                      textAlign: "center",
                    },
                  ]}
                >
                  Failure to check in will allow your opponent to replace you.
                </Text>
              </View>
            </View>
          </View>
        </ScrollView>
      </View>

      {<ShowLoader showIndicater={showLoader} />}
    </Modal>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },
    scrollView: {
      width: "100%",
    },
    mainView: {
      width: "80%",
      maxWidth: 761,
      backgroundColor: AppColors.purple_453B50,
      padding: 24,
      marginHorizontal: 40,
      marginVertical: 30,
      alignSelf: "center",
      borderRadius: 24,
      borderWidth: 1,
      borderColor: AppColors.gray_A6A3AA,
    },
    headerView: {
      flexDirection: "row",
      justifyContent: "space-between",
      gap: 16,
    },
    headerText: {
      color: AppColors.white,
      fontSize: 24,
    },
    CheckNowButtonStyle: {
      paddingVertical: 10,
      paddingHorizontal: 14,
      shadowOpacity: 0,
      borderRadius: 10,
      height: 35,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      boxShadow: `0px 0px 0px 1px ${AppColors.appViolentColor_6D08C3}`,
    },
    timeContainer: {
      flexDirection: "row",
      justifyContent: "space-between",
      gap: 12,
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {
      mainView: {
        width: "60%",
        maxWidth: "auto",
        padding: 12,
        marginHorizontal: 10,
        marginVertical: 30,
        borderRadius: 12,
      },
      headerText: {
        fontSize: 22,
      },
    },
    [DEVICE_SIZES.XS]: {
      mainView: {
        width: "90%",
        maxWidth: "auto",
        marginHorizontal: 10,
        marginVertical: 30,
        padding: 12,
        borderRadius: 12,
      },
      headerText: {
        fontSize: 22,
      },
    },
  }
);
